'use strict';

import 'es6-promise';
import 'whatwg-fetch';
import 'svgxuse';
import 'element-qsa-scope';
import 'focus-visible';

import './preface.scss';
import './favicon.ico';
import './component.scss';
import 'components/complement';
import 'components/typography';
import 'components/page-header';
import 'components/page-footer';
import 'components/page-title';
import 'components/page-burger-menu';
import 'components/page-container';
import 'components/page-layout';
import 'components/branding';
import 'components/system-edition';
import 'components/errors';
import 'components/profile-badge';
import 'components/button';
import 'components/button/btn';
import 'components/language-switch';
import 'components/form';
import 'components/icon';
import 'components/loading';
import 'components/toast-notifications';
import 'components/marketing-message';
import 'components/link';
import 'components/notifications';
import 'components/error-notification';
import 'components/skip-link';
import 'components/session-expiry';
import 'components/modal-dialog';
import 'components/modal-dialog/dialog';
import 'components/back';
import 'components/fluid-flow/trip-summary-bar';

import Tooltip from 'components/tooltip';
import Utils from 'components/utils';
import storage from 'components/storage';
import './onetrust.js';
import Matomo from './matomo.js';
import jsonConfiguration from 'components/complement/json-configuration';
import IconTooltip from 'components/icon';

storage.shared.trackPage(document.documentElement.dataset.page);

new IconTooltip().init();

// 'Inform' cytric that javascript is enabled on the server.
if (document.documentElement.dataset.thirdPartyCookieSetup == 'regular') {
    document.cookie = 'IFAOCYTRICSCRIPT=1; SameSite=None; Secure';
} else if (document.documentElement.dataset.thirdPartyCookieSetup == 'partitioned') {
    document.cookie = 'IFAOCYTRICSCRIPT=1; SameSite=None; Secure; Partitioned';
} else {
    document.cookie = 'IFAOCYTRICSCRIPT=1; SameSite=None; Secure; Max-Age=0';
    document.cookie = 'IFAOCYTRICSCRIPT=1; SameSite=None; Secure; Partitioned';
}


document.documentElement.dataset.selfUrl
    && history.state
    && history.replaceState(history.state, document.title, document.documentElement.dataset.selfUrl);


const pageConfig ={
    MSTeams: {
        isEmbedded: document.documentElement.dataset.loginSource == 'MST'
    }
}

// In Safari browser when the back/forward buttons are used the page is loaded directly from the cache which makes problems
if (Utils.isSafari()) {
    window.addEventListener("pageshow", function(event) {
        // Check if the page is loading from a cache
        if (event.persisted) {
            // Prevent the view of the loaded page from the cache
            document.querySelector('body').style.display = 'none';
            window.location.reload();
        }
    });
}

let matomoJsonObject = jsonConfiguration('global-meta-data');
let matomoEndPoint = null;
if (Object.keys(matomoJsonObject.matomo).length !== 0)
    matomoEndPoint=   matomoJsonObject.matomo.set.trackerUrl;

/*
 * Init the analytics tool
 * The script returns and set the needed information and initializes the tool
 * Matomo can be enabled/disabled in ibe.properties
 */
if (matomoEndPoint !== null) {
    const analyticsTool = new Matomo();
    analyticsTool.init();
    window.analyticsTool = analyticsTool;
}

/*
 * Init tooltips
 */
export const tooltips = new Tooltip();
tooltips.init();

export default { pageConfig }